import { flowRight } from 'lodash';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { focusInsurancePicker } from '@zocdoc/components/src/InsurancePicker';
import {
    trackClickJoin,
    trackClickSignIn,
    trackClickSignInDropdown,
    trackClickSignInDropdownLink,
    trackPageHeaderCTALinkClick,
    trackPageHeaderLogoClick,
} from '../../Shared/Header/eventTrackingActions';
import { getLocation } from '../../config/location/selectors';
import { getSearchMetadata } from '../state/metadata';
import { getSearchParameters } from '../state/parameters';
import { getThemeParameters } from '../../config/theme';
import { PAGE_SIZE } from './constants';
import SearchPageContainer from './container';
import {
    showFacetedSearchBar,
    showSalpBlock,
    showWellGuideLink,
} from '../../config/ab/selector';
import { withSearchResults } from './withSearchResults';
import { trackConversion as trackSignInLinkClickConversion } from '../../config/ab/actions';
import { isSeoUrl } from '../utils/isSeoUrl';
import isZocdocBrand from '../../utils/isZocdocBrand';

const mapStateToProps = state => {
    const location = getLocation(state);
    const parameters = getSearchParameters(state);
    const theme = getThemeParameters(state);

    /**
     * We need specialtyId and procedureId for the proceduresBySpecialty query
     * used in the VisitReasons drop down
     *
     * It's being called here so both the proceduresBySpecialty and the search
     * queries are issued in parallel, and the results are cached to be used
     * by VisitReasons
     */
    const { specialtyId, procedureId } = parameters;

    const is1Z = isZocdocBrand(theme.directoryId);
    const shouldShowSalpSeoContent = is1Z && isSeoUrl(location.pathname);
    const shouldShowSalpBlock = shouldShowSalpSeoContent && showSalpBlock(state);

    const shouldShowWellGuideLink = showWellGuideLink(state);

    return {
        useFacetedSearch: showFacetedSearchBar(state),
        is1Z,
        isNewPatient: true,
        metadata: getSearchMetadata(state),
        pageSize: PAGE_SIZE,
        parameters,
        procedureId,
        shouldShowSalpBlock,
        shouldShowSalpSeoContent,
        shouldShowWellGuideLink,
        specialtyId,
    };
};

const mapDispatchToProps = {
    focusInsurancePicker,
    trackClickJoin,
    trackClickSignIn,
    trackClickSignInDropdown,
    trackClickSignInDropdownLink,
    trackPageHeaderCTALinkClick,
    trackPageHeaderLogoClick,
    trackSignInLinkClickConversion,
};

/**
 * SearchPageWithData is being used in the screenshot tests,
 * which do not mock the router and do not need hot reload
 */
export const SearchPageWithData = flowRight(
    withTheme,
    connect(mapStateToProps, mapDispatchToProps),
    withSearchResults,
)(SearchPageContainer);

export default flowRight(
    hot(module),
    withRouter,
)(SearchPageWithData);
